class Platform {
    constructor(title, api, logo, isShow = true) {
        this.title = title;
        this.api = api;
        this.logo = logo;
        this.updateTime = '';
        this.type = '';
        this.data = [];
        this.loading = true;
        this.isShow = isShow;
    }
}

import {createStore} from 'vuex';
import {
    topSearchForYoutube,
    topSearchForBaiDu,
    topSearchForGitHubAllStars,
    topSearchForDouYin,
    topSearchForBilibili,
    topSearchForWeiBo,
    topSearchForGitHubDaystars,
    topSearchForGitHubWeekstars,
    topSearchForGitHubMonthstars,
    topSearchForGitHubYearstars,
    topSearchForGitHubThreeYearStars,
    topSearchForGitHubFiveYearStars,
    topSearchForGitHubTenYearStars,
    topSearchForDouBan,
    topSearchForTencent,
    topSearchForTouTiao,
    topSearchForWangYi,
    topSearchForWangYiYunBiaoSheng,
    topSearchForWangYiYunXinGe,
    topSearchForWangYiYunYuanChuang,
    topSearchForWangYiYunReGe,
    // topSearchForBaiDuTieBa,
    // topSearchForShaoShuPai,
    topSearchForDianShiJuBaiDu,
    topSearchForDianYingBaiDu,
    topSearchForXiaoShuoBaiDu,
    topSearchForYouXiBaiDu,
    topSearchForQiCheBaiDu,
    topSearchForReGengBaiDu,
    topSearchForCaiJingBaiDu,
    topSearchForMinShengBaiDu,
    topSearchForHuggingFaceSpaceTrending,
    topSearchForHuggingFaceSpaceLikes,
    topSearchForHuggingFaceModelTrending,
    topSearchForHuggingFaceModelLikes,
    topSearchForHuggingFaceDatasetsTrending, topSearchForHuggingFaceDatasetsLikes, topSearchForZhiHu,
    topSearchForDianShiJuTengXun,
    topSearchForDianYingTengXun,
    topSearchForDongManTengXun,
    topSearchForZongYiTengXun,
    topSearchForZongBangTengXun,
    topSearchForDianShiJuAiQiYi,
    topSearchForDianYingAiQiYi,
    topSearchForDongManAiQiYi,
    topSearchForZongYiAiQiYi,
    topSearchForZongBangAiQiYi,
    topSearchForDianShiJuYouKu,
    topSearchForDianYingYouKu,
    topSearchForDongManYouKu,
    topSearchForZongYiYouKu,
    topSearchForZongBangYouKu,
    topSearchForDianShiJuMangGuo,
    topSearchForDianYingMangGuo,
    topSearchForDongManMangGuo,
    topSearchForZongYiMangGuo,
    topSearchForZongBangMangGuo,
    topSearchForZhouPiaoFangBangMaoYan,
    topSearchForXiangkanBangMaoYan,
    topSearchForGouPiaoPingFenBangMaoYan,
    topSearchForTop100MaoYan
,
} from '@/api/api';

import {
    topSearchFor36kr,
    topSearchFor51cto,
    topSearchFor52pojie,
    topSearchForAcfun,
    // topSearchForBaidu,
    // topSearchForCoolapk,
    topSearchForCsdn,
    // topSearchForDgtle, //删除,感觉内容也没那么好
    topSearchForDoubanGroup,
    topSearchForDoubanMovie,
    // topSearchForDouyin,
    // topSearchForEarthquake,
    topSearchForGeekpark,
    // topSearchForGenshin, //与原本的重复
    topSearchForGithub,
    topSearchForGuokr,
    // topSearchForHackernews, 都是英文删除了
    topSearchForHellogithub,
    // topSearchForHistory,  内容不行
    topSearchForHonkai,
    // topSearchForHostloc,  不稳定
    topSearchForHupu,
    // topSearchForHuxiu,
    // topSearchForIfanr,
    // topSearchForIthomeXijiayi,  和it之家重叠了,本身也不那么热门,删除一个
    topSearchForIthome,
    // topSearchForJianshu,
    topSearchForJuejin,
    // topSearchForKuaishou,
    // topSearchForLinuxdo,
    topSearchForLol,
    topSearchForMiyoushe,
    // topSearchForNeteaseNews,
    // topSearchForNewsmth,  手机端的电脑显示不清楚
    topSearchForNgabbs,
    topSearchForNodeseek,
    // topSearchForNytimes,  不翻墙打不开,屏蔽
    // topSearchForProducthunt,
    // topSearchForQqNews,
    topSearchForSinaNews,
    // topSearchForSina,  ai内容,去除
    topSearchForSmzdm,
    topSearchForSspai,
    topSearchForStarrail,
    topSearchForThepaper,
    topSearchForTieba,
    // topSearchForToutiao,  原本已经有了,可以去除
    topSearchForV2ex,
    // topSearchForWeatheralarm, 内容感觉无用,先注释
    // topSearchForWeibo, 与原本的重复,先注释
    topSearchForWeread,
    // topSearchForXueqiu,  雪球,接口显示不出来
    topSearchForYystv,
    // topSearchForZhihuDaily,  内容太差
    // topSearchForZhihu    知乎,接口挂了
  } from '@/api/api2';

export default createStore({
    state: {
        // 实时在线人数
        umamiActive: '🚀',
        // 今日访问量
        umamiTodayViews: '🚀',
        // 今日访问时长
        umamiTodayTime: '🚀',
        // 总访问量
        umamiAllViews: '🚀',
        // 总访问时长
        umamiAllTime: '🚀',
        categroies: [
            {
                name: '全部',
                isShow: true,
                subCategories: [
                    new Platform('知乎', topSearchForZhiHu, require('@/assets/logos/tgmeng-trend_zhihu.png')),
                    new Platform('头条', topSearchForTouTiao, require('@/assets/logos/tgmeng-trend_toutiao.png')),
                    new Platform('B站', topSearchForBilibili, require('@/assets/logos/tgmeng-trend_bilibili.png')),
                    new Platform('微信读书', topSearchForWeread, require('@/assets/logos/hotLog/weread.png')),
                    new Platform('少数派', topSearchForSspai, require('@/assets/logos/hotLog/sspai.png')),
                    new Platform('吾爱破解', topSearchFor52pojie, require('@/assets/logos/hotLog/52pojie.png')),
                    new Platform('HelloGithub', topSearchForHellogithub, require('@/assets/logos/hotLog/hellogithub.png')),
                    new Platform('什么值得买', topSearchForSmzdm, require('@/assets/logos/hotLog/smzdm.png')),
                    new Platform('网易云 热歌榜', topSearchForWangYiYunReGe, require('@/assets/logos/tgmeng-trend_wangyiyun.png')),
                    new Platform('豆瓣电影', topSearchForDoubanMovie, require('@/assets/logos/hotLog/douban-movie.png')),
                    new Platform('腾讯视频 动漫', topSearchForDongManTengXun, require('@/assets/logos/tgmeng-trend_tengxunshipin.png')),
                    new Platform('米游社*原神', topSearchForMiyoushe, require('@/assets/logos/hotLog/miyoushe.png')),
                ],
            },

            {
                name: '综合',
                isShow: false,
                subCategories: [
                    new Platform('知乎', topSearchForZhiHu, require('@/assets/logos/tgmeng-trend_zhihu.png')),
                    new Platform('头条', topSearchForTouTiao, require('@/assets/logos/tgmeng-trend_toutiao.png')),
                    new Platform('B站', topSearchForBilibili, require('@/assets/logos/tgmeng-trend_bilibili.png')),
                    new Platform('微信读书', topSearchForWeread, require('@/assets/logos/hotLog/weread.png')),
                    new Platform('少数派', topSearchForSspai, require('@/assets/logos/hotLog/sspai.png')),
                    new Platform('吾爱破解', topSearchFor52pojie, require('@/assets/logos/hotLog/52pojie.png')),
                    new Platform('HelloGithub', topSearchForHellogithub, require('@/assets/logos/hotLog/hellogithub.png')),
                    new Platform('什么值得买', topSearchForSmzdm, require('@/assets/logos/hotLog/smzdm.png')),
                    new Platform('网易云 热歌榜', topSearchForWangYiYunReGe, require('@/assets/logos/tgmeng-trend_wangyiyun.png')),
                    new Platform('豆瓣电影', topSearchForDoubanMovie, require('@/assets/logos/hotLog/douban-movie.png')),
                    new Platform('腾讯视频 动漫', topSearchForDongManTengXun, require('@/assets/logos/tgmeng-trend_tengxunshipin.png')),
                    new Platform('米游社*原神', topSearchForMiyoushe, require('@/assets/logos/hotLog/miyoushe.png')),
                ]
            },

            {
                name: '新闻',
                isShow: true,
                subCategories: [
                    new Platform('微博', topSearchForWeiBo, require('@/assets/logos/tgmeng-trend_weibo.png')),
                    new Platform('腾讯', topSearchForTencent, require('@/assets/logos/tgmeng-trend_tencent.png')),
                    new Platform('网易', topSearchForWangYi, require('@/assets/logos/tgmeng-trend_wangyi.png')),
                    new Platform('百度', topSearchForBaiDu, require('@/assets/logos/tgmeng-trend_baidu.png')),
                    new Platform('澎湃新闻', topSearchForThepaper, require('@/assets/logos/hotLog/thepaper.png')),
                    new Platform('新浪财经', topSearchForSinaNews, require('@/assets/logos/hotLog/sinaNews.png')),
                ]
            },

            {
                name: '娱乐',
                isShow: true,
                subCategories: [
                    new Platform('Acfun', topSearchForAcfun, require('@/assets/logos/hotLog/acfun.png')),
                    new Platform('Youtube', topSearchForYoutube, require('@/assets/logos/tgmeng-trend_youtube.png')),
                    new Platform('热梗', topSearchForReGengBaiDu, require('@/assets/logos/tgmeng-trend_regeng.png')),
                    new Platform('抖音', topSearchForDouYin, require('@/assets/logos/tgmeng-trend_douyin.png')),
                ]
            },

            
            {
                name: '科技',
                isShow: true,
                subCategories: [
                    new Platform('36氪', topSearchFor36kr, require('@/assets/logos/hotLog/36kr.png')),
                    new Platform('少数派', topSearchForSspai, require('@/assets/logos/hotLog/sspai.png')),
                    new Platform('51cto', topSearchFor51cto, require('@/assets/logos/hotLog/51cto.png')),
                    new Platform('果壳', topSearchForGuokr, require('@/assets/logos/hotLog/guokr.png')),
                ]
            },

            {
                name: '社区',
                isShow: true,
                subCategories: [
                    new Platform('财经', topSearchForCaiJingBaiDu, require('@/assets/logos/tgmeng-trend_caijing.png')),
                    new Platform('百度贴吧', topSearchForTieba, require('@/assets/logos/hotLog/tieba.png')),
                    new Platform('虎扑社区', topSearchForHupu, require('@/assets/logos/hotLog/hupu.png')),
                    new Platform('民生', topSearchForMinShengBaiDu, require('@/assets/logos/tgmeng-trend_minsheng.png')),
                    new Platform('汽车', topSearchForQiCheBaiDu, require('@/assets/logos/tgmeng-trend_youxi.png')),
                    new Platform('豆瓣热榜', topSearchForDouBan, require('@/assets/logos/tgmeng-trend_douban.png')),
                    new Platform('豆瓣小组', topSearchForDoubanGroup, require('@/assets/logos/hotLog/douban-group.png')),
                    new Platform('精英玩家俱乐部', topSearchForNgabbs, require('@/assets/logos/hotLog/ngabbs.png')),
                    new Platform('Geekpark', topSearchForGeekpark, require('@/assets/logos/hotLog/geekpark.png')), 
                ]
            },

            {
                name: 'IT',
                isShow: true,
                subCategories: [
                    new Platform('Github', topSearchForGithub, require('@/assets/logos/hotLog/github.png')),
                    new Platform('Csdn', topSearchForCsdn, require('@/assets/logos/hotLog/csdn.png')),
                    new Platform('V2ex', topSearchForV2ex, require('@/assets/logos/hotLog/v2ex.png')),
                    new Platform('Nodeseek', topSearchForNodeseek, require('@/assets/logos/hotLog/nodeseek.png')),
                    new Platform('IT之家', topSearchForIthome, require('@/assets/logos/hotLog/ithome.png')),
                    new Platform('稀土掘金', topSearchForJuejin, require('@/assets/logos/hotLog/juejin.png')),
                    new Platform('Star总榜', topSearchForGitHubAllStars, require('@/assets/logos/tgmeng-trend_github.png')),
                    new Platform('近一日新仓库Star榜', topSearchForGitHubDaystars, require('@/assets/logos/tgmeng-trend_github.png')),
                    new Platform('近一周新仓库Star榜', topSearchForGitHubWeekstars, require('@/assets/logos/tgmeng-trend_github.png')),
                    new Platform('近一月新仓库Star榜', topSearchForGitHubMonthstars, require('@/assets/logos/tgmeng-trend_github.png')),
                    new Platform('近一年新仓库Star榜', topSearchForGitHubYearstars, require('@/assets/logos/tgmeng-trend_github.png')),
                    new Platform('近三年新仓库Star榜', topSearchForGitHubThreeYearStars, require('@/assets/logos/tgmeng-trend_github.png')),
                    new Platform('近五年新仓库Star榜', topSearchForGitHubFiveYearStars, require('@/assets/logos/tgmeng-trend_github.png')),
                    new Platform('近十年新仓库Star榜', topSearchForGitHubTenYearStars, require('@/assets/logos/tgmeng-trend_github.png')),
                    new Platform('Spaces热门榜', topSearchForHuggingFaceSpaceTrending, require('@/assets/logos/tgmeng-trend_huggingface.png')),
                    new Platform('Spaces点赞榜', topSearchForHuggingFaceSpaceLikes, require('@/assets/logos/tgmeng-trend_huggingface.png')),
                    new Platform('Models热门榜', topSearchForHuggingFaceModelTrending, require('@/assets/logos/tgmeng-trend_huggingface.png')),
                    new Platform('Models点赞榜', topSearchForHuggingFaceModelLikes, require('@/assets/logos/tgmeng-trend_huggingface.png')),
                    new Platform('Datasets热门榜', topSearchForHuggingFaceDatasetsTrending, require('@/assets/logos/tgmeng-trend_huggingface.png')),
                    new Platform('Datasets点赞榜', topSearchForHuggingFaceDatasetsLikes, require('@/assets/logos/tgmeng-trend_huggingface.png')),
                ]
            },

            {
                name: '影视',
                isShow: true,
                subCategories: [
                    new Platform('猫眼 周票房榜', topSearchForZhouPiaoFangBangMaoYan, require('@/assets/logos/tgmeng-trend_maoyan.png')),
                    new Platform('猫眼 想看榜', topSearchForXiangkanBangMaoYan, require('@/assets/logos/tgmeng-trend_maoyan.png')),
                    new Platform('猫眼 购票评分榜', topSearchForGouPiaoPingFenBangMaoYan, require('@/assets/logos/tgmeng-trend_maoyan.png')),
                    new Platform('猫眼 历史总榜', topSearchForTop100MaoYan, require('@/assets/logos/tgmeng-trend_maoyan.png')),

                    new Platform('腾讯视频 电视剧', topSearchForDianShiJuTengXun, require('@/assets/logos/tgmeng-trend_tengxunshipin.png')),
                    new Platform('爱奇艺 电视剧', topSearchForDianShiJuAiQiYi, require('@/assets/logos/tgmeng-trend_aiqiyi.png')),
                    new Platform('芒果 电视剧', topSearchForDianShiJuMangGuo, require('@/assets/logos/tgmeng-trend_mangguo.png')),
                    new Platform('优酷 电视剧', topSearchForDianShiJuYouKu, require('@/assets/logos/tgmeng-trend_youku.png')),

                    new Platform('腾讯视频 电影', topSearchForDianYingTengXun, require('@/assets/logos/tgmeng-trend_tengxunshipin.png')),
                    new Platform('爱奇艺 电影', topSearchForDianYingAiQiYi, require('@/assets/logos/tgmeng-trend_aiqiyi.png')),
                    new Platform('芒果 电影', topSearchForDianYingMangGuo, require('@/assets/logos/tgmeng-trend_mangguo.png')),
                    new Platform('优酷 电影', topSearchForDianYingYouKu, require('@/assets/logos/tgmeng-trend_youku.png'),false),

                    new Platform('腾讯视频 动漫', topSearchForDongManTengXun, require('@/assets/logos/tgmeng-trend_tengxunshipin.png')),
                    new Platform('爱奇艺 动漫', topSearchForDongManAiQiYi, require('@/assets/logos/tgmeng-trend_aiqiyi.png')),
                    new Platform('芒果 动漫', topSearchForDongManMangGuo, require('@/assets/logos/tgmeng-trend_mangguo.png')),
                    new Platform('优酷 动漫', topSearchForDongManYouKu, require('@/assets/logos/tgmeng-trend_youku.png')),

                    new Platform('腾讯视频 综艺', topSearchForZongYiTengXun, require('@/assets/logos/tgmeng-trend_tengxunshipin.png')),
                    new Platform('爱奇艺 综艺', topSearchForZongYiAiQiYi, require('@/assets/logos/tgmeng-trend_aiqiyi.png')),
                    new Platform('芒果 综艺', topSearchForZongYiMangGuo, require('@/assets/logos/tgmeng-trend_mangguo.png')),
                    new Platform('优酷 综艺', topSearchForZongYiYouKu, require('@/assets/logos/tgmeng-trend_youku.png')),

                    new Platform('腾讯视频 总榜', topSearchForZongBangTengXun, require('@/assets/logos/tgmeng-trend_tengxunshipin.png')),
                    new Platform('爱奇艺 总榜', topSearchForZongBangAiQiYi, require('@/assets/logos/tgmeng-trend_aiqiyi.png')),
                    new Platform('芒果 总榜', topSearchForZongBangMangGuo, require('@/assets/logos/tgmeng-trend_mangguo.png')),
                    new Platform('优酷 总榜', topSearchForZongBangYouKu, require('@/assets/logos/tgmeng-trend_youku.png')),

                    new Platform('百度 电视剧', topSearchForDianShiJuBaiDu, require('@/assets/logos/tgmeng-trend_dianshiju.png')),
                    new Platform('百度 电影', topSearchForDianYingBaiDu, require('@/assets/logos/tgmeng-trend_dianying.png')),
                ]
            },
 
            {
                name: '阅读',
                isShow: true,
                subCategories: [
                    new Platform('微信读书', topSearchForWeread, require('@/assets/logos/hotLog/weread.png')),
                    new Platform('小说', topSearchForXiaoShuoBaiDu, require('@/assets/logos/tgmeng-trend_xiaoshuo.png')),
                ]
            },

            {
                name: '音乐',
                isShow: true,
                subCategories: [
                    new Platform('网易云 飙升榜', topSearchForWangYiYunBiaoSheng, require('@/assets/logos/tgmeng-trend_wangyiyun.png')),
                    new Platform('网易云 新歌榜', topSearchForWangYiYunXinGe, require('@/assets/logos/tgmeng-trend_wangyiyun.png')),
                    new Platform('网易云 原创榜', topSearchForWangYiYunYuanChuang, require('@/assets/logos/tgmeng-trend_wangyiyun.png')),
                    new Platform('网易云 热歌榜', topSearchForWangYiYunReGe, require('@/assets/logos/tgmeng-trend_wangyiyun.png')),
                ]
            },

            {
                name: '游戏',
                isShow: true,
                subCategories: [
                    new Platform('米游社*原神', topSearchForMiyoushe, require('@/assets/logos/hotLog/miyoushe.png')),
                    new Platform('英雄联盟', topSearchForLol, require('@/assets/logos/hotLog/lol.png')),
                    new Platform('米游社*崩坏:星穹铁道', topSearchForStarrail, require('@/assets/logos/hotLog/starrail.png')),
                    new Platform('游研社', topSearchForYystv, require('@/assets/logos/hotLog/yystv.png')),
                    new Platform('游戏', topSearchForYouXiBaiDu, require('@/assets/logos/tgmeng-trend_qiche.png')),
                    new Platform('米游社*崩坏3', topSearchForHonkai, require('@/assets/logos/hotLog/honkai.png')),
                ]
            },


            // {
            //     name: '新闻',
            //     isShow: true,
            //     subCategories: [
            //         new Platform('腾讯', topSearchForTencent, require('@/assets/logos/tgmeng-trend_tencent.png')),//上面已用
            //         new Platform('头条', topSearchForTouTiao, require('@/assets/logos/tgmeng-trend_toutiao.png')),//上面已用
            //         new Platform('网易', topSearchForWangYi, require('@/assets/logos/tgmeng-trend_wangyi.png')),//上面已用
            //         new Platform('百度', topSearchForBaiDu, require('@/assets/logos/tgmeng-trend_baidu.png')),//上面已用
            //     ]
            // },
            // {
            //     name: '媒体',
            //     isShow: true,
            //     subCategories: [
                    // new Platform('B站', topSearchForBilibili, require('@/assets/logos/tgmeng-trend_bilibili.png')),//上面已用
                    // new Platform('抖音', topSearchForDouYin, require('@/assets/logos/tgmeng-trend_douyin.png')),//上面已用
                    // new Platform('Youtube', topSearchForYoutube, require('@/assets/logos/tgmeng-trend_youtube.png')),//上面已用
                    // new Platform('热梗', topSearchForReGengBaiDu, require('@/assets/logos/tgmeng-trend_regeng.png')),//上面已用
                    // new Platform('财经', topSearchForCaiJingBaiDu, require('@/assets/logos/tgmeng-trend_caijing.png')), --//上面已用
                    // new Platform('民生', topSearchForMinShengBaiDu, require('@/assets/logos/tgmeng-trend_minsheng.png')),//上面已用
                    // new Platform('汽车', topSearchForQiCheBaiDu, require('@/assets/logos/tgmeng-trend_youxi.png')),//上面已用
                    // new Platform('游戏', topSearchForYouXiBaiDu, require('@/assets/logos/tgmeng-trend_qiche.png')), //上面已用
                    // new Platform('小说', topSearchForXiaoShuoBaiDu, require('@/assets/logos/tgmeng-trend_xiaoshuo.png')), --//上面已用
            //     ]
            // },
            // {
            //     name: '影视',
            //     isShow: true,
            //     subCategories: [
            //         new Platform('猫眼 周票房榜', topSearchForZhouPiaoFangBangMaoYan, require('@/assets/logos/tgmeng-trend_maoyan.png')),
            //         new Platform('猫眼 想看榜', topSearchForXiangkanBangMaoYan, require('@/assets/logos/tgmeng-trend_maoyan.png')),
            //         new Platform('猫眼 购票评分榜', topSearchForGouPiaoPingFenBangMaoYan, require('@/assets/logos/tgmeng-trend_maoyan.png')),
            //         new Platform('猫眼 历史总榜', topSearchForTop100MaoYan, require('@/assets/logos/tgmeng-trend_maoyan.png')),

            //         new Platform('腾讯视频 电视剧', topSearchForDianShiJuTengXun, require('@/assets/logos/tgmeng-trend_tengxunshipin.png')),
            //         new Platform('爱奇艺 电视剧', topSearchForDianShiJuAiQiYi, require('@/assets/logos/tgmeng-trend_aiqiyi.png')),
            //         new Platform('芒果 电视剧', topSearchForDianShiJuMangGuo, require('@/assets/logos/tgmeng-trend_mangguo.png')),
            //         new Platform('优酷 电视剧', topSearchForDianShiJuYouKu, require('@/assets/logos/tgmeng-trend_youku.png')),

            //         new Platform('腾讯视频 电影', topSearchForDianYingTengXun, require('@/assets/logos/tgmeng-trend_tengxunshipin.png')),
            //         new Platform('爱奇艺 电影', topSearchForDianYingAiQiYi, require('@/assets/logos/tgmeng-trend_aiqiyi.png')),
            //         new Platform('芒果 电影', topSearchForDianYingMangGuo, require('@/assets/logos/tgmeng-trend_mangguo.png')),
            //         new Platform('优酷 电影', topSearchForDianYingYouKu, require('@/assets/logos/tgmeng-trend_youku.png'),false),

            //         new Platform('腾讯视频 动漫', topSearchForDongManTengXun, require('@/assets/logos/tgmeng-trend_tengxunshipin.png')),
            //         new Platform('爱奇艺 动漫', topSearchForDongManAiQiYi, require('@/assets/logos/tgmeng-trend_aiqiyi.png')),
            //         new Platform('芒果 动漫', topSearchForDongManMangGuo, require('@/assets/logos/tgmeng-trend_mangguo.png')),
            //         new Platform('优酷 动漫', topSearchForDongManYouKu, require('@/assets/logos/tgmeng-trend_youku.png')),

            //         new Platform('腾讯视频 综艺', topSearchForZongYiTengXun, require('@/assets/logos/tgmeng-trend_tengxunshipin.png')),
            //         new Platform('爱奇艺 综艺', topSearchForZongYiAiQiYi, require('@/assets/logos/tgmeng-trend_aiqiyi.png')),
            //         new Platform('芒果 综艺', topSearchForZongYiMangGuo, require('@/assets/logos/tgmeng-trend_mangguo.png')),
            //         new Platform('优酷 综艺', topSearchForZongYiYouKu, require('@/assets/logos/tgmeng-trend_youku.png')),

            //         new Platform('腾讯视频 总榜', topSearchForZongBangTengXun, require('@/assets/logos/tgmeng-trend_tengxunshipin.png')),
            //         new Platform('爱奇艺 总榜', topSearchForZongBangAiQiYi, require('@/assets/logos/tgmeng-trend_aiqiyi.png')),
            //         new Platform('芒果 总榜', topSearchForZongBangMangGuo, require('@/assets/logos/tgmeng-trend_mangguo.png')),
            //         new Platform('优酷 总榜', topSearchForZongBangYouKu, require('@/assets/logos/tgmeng-trend_youku.png')),

            //         new Platform('百度 电视剧', topSearchForDianShiJuBaiDu, require('@/assets/logos/tgmeng-trend_dianshiju.png')),
            //         new Platform('百度 电影', topSearchForDianYingBaiDu, require('@/assets/logos/tgmeng-trend_dianying.png')),
            //     ]
            // },
            // {
            //     name: '音乐',
            //     isShow: true,
            //     subCategories: [
            //         new Platform('网易云 飙升榜', topSearchForWangYiYunBiaoSheng, require('@/assets/logos/tgmeng-trend_wangyiyun.png')),
            //         new Platform('网易云 新歌榜', topSearchForWangYiYunXinGe, require('@/assets/logos/tgmeng-trend_wangyiyun.png')),
            //         new Platform('网易云 原创榜', topSearchForWangYiYunYuanChuang, require('@/assets/logos/tgmeng-trend_wangyiyun.png')),
            //         new Platform('网易云 热歌榜', topSearchForWangYiYunReGe, require('@/assets/logos/tgmeng-trend_wangyiyun.png')),
            //     ]
            // },
            // {
            //     name: '社交',  //放社区了
            //     isShow: true,
            //     subCategories: [
            //         new Platform('微博', topSearchForWeiBo, require('@/assets/logos/tgmeng-trend_weibo.png')),
            //         new Platform('知乎', topSearchForZhiHu, require('@/assets/logos/tgmeng-trend_zhihu.png')),
            //         new Platform('百度贴吧', topSearchForBaiDuTieBa, require('@/assets/logos/tgmeng-trend_baidutieba.png')),
            //         new Platform('豆瓣', topSearchForDouBan, require('@/assets/logos/tgmeng-trend_douban.png')),
            //         new Platform('少数派', topSearchForShaoShuPai, require('@/assets/logos/tgmeng-trend_shaoshupai.png')),
            //     ]
            // },
            
            // {
            //     name: '测试',
            //     isShow: true,
            //     subCategories: [
                    // new Platform('36氪', topSearchFor36kr, require('@/assets/logos/hotLog/36kr.png')), //上面已用
                    // new Platform('51cto', topSearchFor51cto, require('@/assets/logos/hotLog/51cto.png')), //上面已用
                    // new Platform('吾爱破解', topSearchFor52pojie, require('@/assets/logos/hotLog/52pojie.png')),//上面已用
                    // new Platform('Acfun', topSearchForAcfun, require('@/assets/logos/hotLog/acfun.png')),//上面已用
                    // new Platform('百度', topSearchForBaidu, require('@/assets/logos/hotLog/baidu.png')),//上面已用
                    // new Platform('Coolapk', topSearchForCoolapk, require('@/assets/logos/hotLog/36kr.png')),
                    // new Platform('Csdn', topSearchForCsdn, require('@/assets/logos/hotLog/csdn.png')), //上面已用
                    // new Platform('数字尾巴', topSearchForDgtle, require('@/assets/logos/hotLog/36kr.png')), //上面已用
                    // new Platform('豆瓣小组', topSearchForDoubanGroup, require('@/assets/logos/hotLog/douban-group.png')), //上面已用
                    // new Platform('豆瓣电影', topSearchForDoubanMovie, require('@/assets/logos/hotLog/douban-movie.png')),//上面已用
                    // new Platform('抖音', topSearchForDouyin, require('@/assets/logos/hotLog/douyin.png')), //和原来的重复
                    // new Platform('Earthquake', topSearchForEarthquake, require('@/assets/logos/hotLog/36kr.png')),
                    // new Platform('Geekpark', topSearchForGeekpark, require('@/assets/logos/hotLog/geekpark.png')), //上面已用
                    // new Platform('米游社', topSearchForGenshin, require('@/assets/logos/hotLog/genshin.png')), //上面已用
                    // new Platform('Github', topSearchForGithub, require('@/assets/logos/hotLog/github.png')),//上面已用
                    // new Platform('果壳', topSearchForGuokr, require('@/assets/logos/hotLog/guokr.png')), //上面已用
                    // new Platform('Hackernews', topSearchForHackernews, require('@/assets/logos/hotLog/36kr.png')),
                    // new Platform('HelloGithub', topSearchForHellogithub, require('@/assets/logos/hotLog/hellogithub.png')), //上面已用
                    // new Platform('History', topSearchForHistory, require('@/assets/logos/hotLog/36kr.png')),
                    // new Platform('米游社*崩坏3', topSearchForHonkai, require('@/assets/logos/hotLog/honkai.png')),
                    // new Platform('全球主机交流', topSearchForHostloc, require('@/assets/logos/hotLog/hostloc.png')),
                    // new Platform('虎扑社区', topSearchForHupu, require('@/assets/logos/hotLog/hupu.png')),//上面已用
                    // new Platform('Huxiu', topSearchForHuxiu, require('@/assets/logos/hotLog/36kr.png')),
                    // new Platform('微博', topSearchForIfanr, require('@/assets/logos/hotLog/36kr.png')),//与上面重复
                    // new Platform('IthomeXijiayi', topSearchForIthomeXijiayi, require('@/assets/logos/hotLog/36kr.png')),
                    // new Platform('IT之家', topSearchForIthome, require('@/assets/logos/hotLog/ithome.png')), --//上面已用
                    // new Platform('Jianshu', topSearchForJianshu, require('@/assets/logos/hotLog/jianshu.png')),
                    // new Platform('稀土掘金', topSearchForJuejin, require('@/assets/logos/hotLog/juejin.png')), --//上面已用
                    // new Platform('Kuaishou', topSearchForKuaishou, require('@/assets/logos/hotLog/kuaishou.png')),
                    // new Platform('Linuxdo', topSearchForLinuxdo, require('@/assets/logos/hotLog/36kr.png')),
                    // new Platform('英雄联盟', topSearchForLol, require('@/assets/logos/hotLog/lol.png')), --//上面已用
                    // new Platform('米游社*原神', topSearchForMiyoushe, require('@/assets/logos/hotLog/miyoushe.png')), --//上面已用
                    // new Platform('网易新闻', topSearchForNeteaseNews, require('@/assets/logos/hotLog/netease-news.png')),//与上面重复
                    // new Platform('Newsmth', topSearchForNewsmth, require('@/assets/logos/hotLog/36kr.png')),
                    // new Platform('精英玩家俱乐部', topSearchForNgabbs, require('@/assets/logos/hotLog/ngabbs.png')),//上面已用
                    // new Platform('Nodeseek', topSearchForNodeseek, require('@/assets/logos/hotLog/nodeseek.png')),//上面已用
                    // new Platform('纽约时报中文网', topSearchForNytimes, require('@/assets/logos/hotLog/36kr.png')),//上面已用
                    // new Platform('Producthunt', topSearchForProducthunt, require('@/assets/logos/hotLog/36kr.png')),
                    // new Platform('腾讯新闻', topSearchForQqNews, require('@/assets/logos/hotLog/qq-news.png')),//重复
                    // new Platform('新浪财经', topSearchForSinaNews, require('@/assets/logos/hotLog/36kr.png')),
                    // new Platform('Sina', topSearchForSina, require('@/assets/logos/hotLog/36kr.png')), //上面已用
                    // new Platform('什么值得买', topSearchForSmzdm, require('@/assets/logos/hotLog/36kr.png')), --//上面已用
                    // new Platform('少数派', topSearchForSspai, require('@/assets/logos/hotLog/sspai.png')),  --//上面已用
                    // new Platform('米游社*崩坏:星穹铁道', topSearchForStarrail, require('@/assets/logos/hotLog/starrail.png')),--//上面已用
                    // new Platform('澎湃新闻', topSearchForThepaper, require('@/assets/logos/hotLog/thepaper.png')), --//上面已用
                    // new Platform('百度贴吧', topSearchForTieba, require('@/assets/logos/hotLog/tieba.png')), --//上面已用
                    // new Platform('今日头条', topSearchForToutiao, require('@/assets/logos/hotLog/toutiao.png')),
                    // new Platform('V2ex', topSearchForV2ex, require('@/assets/logos/hotLog/v2ex.png')), --//上面已用
                    // new Platform('中央气象台', topSearchForWeatheralarm, require('@/assets/logos/hotLog/weatheralarm.png')), --感觉无用
                    // new Platform('微博', topSearchForWeibo, require('@/assets/logos/hotLog/weibo.png')), --与上面重复
                    // new Platform('微信读书', topSearchForWeread, require('@/assets/logos/hotLog/weread.png')),--//上面已用
                    // new Platform('Xueqiu', topSearchForXueqiu, require('@/assets/logos/hotLog/36kr.png')),
                    // new Platform('游研社', topSearchForYystv, require('@/assets/logos/hotLog/yystv.png')), --//上面已用
                    // new Platform('ZhihuDaily', topSearchForZhihuDaily, require('@/assets/logos/hotLog/zhihu-daily.png')),
                    // new Platform('Zhihu', topSearchForZhihu, require('@/assets/logos/hotLog/zhihu.png'))
            //     ]
            // }
        ], 
    },
});
